export default __webpack_public_path__ + "static/media/call.804df155.png";